
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M288.217 255.997l198.61-198.565c8.896-8.895 8.896-23.314 0-32.208-8.897-8.895-23.32-8.895-32.217 0L256 223.788 57.389 25.253c-8.897-8.895-23.319-8.895-32.216 0-8.896 8.894-8.896 23.314 0 32.209l198.611 198.565L25.203 454.562c-8.896 8.895-8.896 23.313 0 32.21 4.463 4.43 10.263 6.677 16.093 6.677s11.659-2.217 16.093-6.677L256 288.206l198.61 198.565c4.463 4.43 10.263 6.677 16.092 6.677 5.83 0 11.661-2.217 16.095-6.677 8.896-8.896 8.896-23.315 0-32.21l-198.58-198.564z"}})])
          )
        }
      }
    